<template>
  <v-container fluid pa-3 background>
    <v-btn slot="activator" icon @click="backlist()" class="btn_show_filter">
      <v-icon :size="25">reply</v-icon>
    </v-btn>
    <v-layout row wrap pa-3 style="background-color:#fff; margin-top:5px; border-radius:5px;">
      <v-layout row wrap>
        <v-flex xs12 text-xs-right>
          <v-btn style="margin-right:10px; background-color:transparent; box-shadow: none;" @click="info_dialog = true">
            <v-icon style="font-size:16px;padding: 10px 0px;" color="grey">fa-info-circle</v-icon>
            <span>&nbsp;{{ $t("recommend") }}</span>
          </v-btn>
        </v-flex>
      </v-layout>
      <v-flex xs12>
        <v-form ref="form" v-model="form_valid">
          <v-layout row wrap>
            <v-flex md4 sm6 xs12 pa-1>
              <v-text-field v-model="datas.code" required :label="$t('doc_no')" append-icon="fas fa-plus-circle" hide-details @click:append="doNewGuid" />
            </v-flex>
            <v-flex md4 sm6 xs12 pa-1>
              <v-text-field :label="$t('date')" type="date" v-model="datas.date" required hide-details />
            </v-flex>
            <v-flex md4 sm6 xs12 pa-1>
              <v-text-field :label="$t('remark')" type="text" v-model="datas.remark" required hide-details />
            </v-flex>
<!-- 
            <v-flex md4 sm6 xs12 pa-1 v-if="branch_items.length > 0">
              <v-select required :items="branch_items" :label="$t('branch')" item-text="name" item-value="code" v-model="branch" hide-details @input="getProfileDepartmentList()" />
            </v-flex>
            <v-flex md4 sm6 xs12 pa-1 v-if="branch_items.length > 0">
              <v-select
                required
                :items="department_items"
                :label="$t('Department')"
                item-text="name"
                item-value="code"
                v-model="department"
                hide-details
                :disabled="department_items.length == ''"
                @input="getEmployeeList()"
              />
            </v-flex>

            <v-flex md4 sm6 xs12 pa-1>
              <v-autocomplete
                v-model="name"
                :items="Employee_list"
                item-text="name"
                item-value="name"
                :label="$t('employee_code')"
                :disabled="Employee_list.length == ''"
                append-icon="search"
                clearable
                hide-details
                required
                multiple
              >
                <template slot="selection" slot-scope="{ item, index }">
                  <span v-if="index === 0">{{ item.name }}</span>
                  <span v-if="index === 1" class="grey--text caption">(+{{ name.length - 1 }} others)</span>
                </template>
                <template slot="prepend-item">
                  <v-list-tile ripple @click="toggle" class="checkEmp">
                    <v-list-tile-action>
                      <v-checkbox v-model="isChecked" color="primary" :indeterminate="selectSomeEmp"></v-checkbox>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>Select All</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-divider class="mt-2"></v-divider>
                </template>
                <template slot="append-item">
                  <v-divider class="mb-2"></v-divider>
                </template>
              </v-autocomplete>
            </v-flex> -->
            <v-flex lg12 md12 sm12 xs12 text-xs-right>
              <v-layout row warp text-xs-right>
                <v-flex md2 sm6 xs12 class="button-wrapper" v-if="permission_edit == true || admin == 'true'">
                  <span class="label">{{ $t("Upload") }}</span>
                  <input :label="$t('ImportIncome')" type="file" id="file" ref="myFiles" class="upload-box" multiple @change="ImportExcel()" placeholder="Upload File" />
                </v-flex>
                <v-flex md2 sm6 xs12 style="margin-right:15px;" v-if="permission_edit == true || admin == 'true'">
                  <v-btn color="warning" block class="white--text" @click="CreateDoc()">
                    <p style=" font-size:12px;position: absolute; margin-top:15px;">{{ $t("DownloadExample") }}</p>
                  </v-btn>
                </v-flex>
     
              </v-layout>
            </v-flex>
          </v-layout>
        </v-form>
        <div class="text-xs-center">
          <v-dialog v-model="dialog_loading" persistent width="260">
            <v-card>
              <v-card-text>
                Processing... <span v-if="progress > 0">{{ progress }}%</span>
                <v-progress-linear indeterminate color="red" class="mb-0" v-if="empNewList == 0"></v-progress-linear>
                <v-progress-linear :value="progress" max="100"  v-if="progress > 0"></v-progress-linear>
                <div v-if="snackbar">{{ errmsg }}</div>
              </v-card-text>
            </v-card>
          </v-dialog>
        </div>
        <v-flex md12 sm12 xs12 style="margin-top :20px;">
          <v-layout row wrap v-if="IncomeData.length > 0">
            <v-flex xs12 text-xs-right>
              <v-btn color="#D84315" @click="back()">
                <v-icon class="mr-2" style="color:#ffffff">fas fa-arrow-left</v-icon>
                <span style="color:#ffffff">{{ $t("back") }}</span>
              </v-btn>
              <v-btn
                v-if="empNewList.length == 0"
                v-show="!dialog_loading"
                color="#43A047"
                @click="
                  dialog = false;
                  onSave();
                "
              >
                <v-icon class="mr-2" style="color:#ffffff">save</v-icon>
                <span style="color:#ffffff">{{ $t("save") }}</span>
              </v-btn>
              <v-btn
                v-if="empNewList.length > 0"
                v-show="!dialog_loading"
                color="#43A047"
                @click="
                  dialog = false;
                  importEmp();
                "
              >
                <v-icon class="mr-2" style="color:#ffffff">upload</v-icon>
                <span style="color:#ffffff">{{ $t("UploadNewEmp") }} ({{ empNewList.length }})</span>
              </v-btn>
            </v-flex>
            <v-flex
              md12
              sm12
              xs12
              v-for="(item, index) in IncomeData"
              :key="index"
              @click="
                '';


              "
            >
              <v-card class="coco-box-shadow" v-if="!item.status">
                <v-layout align-center justify-center row fill-height wrap class="coco-list-layout">
                  <v-flex lg1 md1 sm2 xs3 text-xs-center>
                    <v-avatar :size="64">
                      <v-avatar v-if="item.emp_images == '' || item.emp_images == undefined || item.emp_images == null" :size="64" color="teal">
                        <span class="white--text headline">{{ item.nick_name }}</span>
                      </v-avatar>

                      <Empimage v-if="item.emp_images != '' && item.emp_images != undefined && item.emp_images != null" :json_data="item.emp_images" />
                    </v-avatar>
                  </v-flex>
                  <v-flex lg9 md9 sm8 xs9>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <span style="color:red;">{{ isEmpty(item.emp_code) ? item.emp_code : "ไม่พบข้อมูล พนักงาน" }}</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex lg2 md2 sm2 xs2>
                    <v-layout row wrap>
                      <v-flex md12 sm12 xs12 text-xs-center>
                        <v-layout row wrap>
                          <v-flex offset-lg5 offset-md3 lg3 md4 xs6>
                            <v-tooltip bottom>
                              <v-btn slot="activator" color="warning" icon flat @click="EditItem(item, index)">
                                <v-icon>edit</v-icon>
                              </v-btn>
                              <span>{{ $t("edit") }}</span>
                            </v-tooltip>
                          </v-flex>
                          <v-flex lg3 md4 xs6>
                            <v-tooltip bottom>
                              <v-btn slot="activator" color="error" icon flat @click="deleteItem(item, index)">
                                <v-icon>delete</v-icon>
                              </v-btn>
                              <span>{{ $t("delete") }}</span>
                            </v-tooltip>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex xs12 offset-md1 offset-sm2 class="coco-list-divider">
                    <v-divider />
                  </v-flex>
                </v-layout>
              </v-card>
              <v-card class="coco-box-shadow coco-list-hover" v-if="item.status">
                <v-layout align-center justify-center row fill-height wrap class="coco-list-layout">
                  <v-flex lg1 md1 sm2 xs3 text-xs-center>
                    <v-avatar :size="64">
                      <v-avatar v-if="item.emp_images == '' || item.emp_images == undefined || item.emp_images == null" :size="64" color="teal">
                        <span class="white--text headline">{{ item.nick_name }}</span>
                      </v-avatar>

                      <Empimage v-if="item.emp_images != '' && item.emp_images != undefined && item.emp_images != null" :json_data="item.emp_images" />
                    </v-avatar>
                  </v-flex>
                  <v-flex lg9 md9 sm8 xs9>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <span class="coco-list-label-text">{{ isEmpty(item.emp_code) ? item.emp_code : "emp_code" }} :</span>
                        <span v-bind:style="[item.resign.toString() == 'true' ? { color: '#F44336' } : { color: '#000000' }]"
                          >{{ item.name_title }} {{ item.first_name }} {{ item.last_name }}</span
                        >
                        <span v-html="' <span style=color:#166BFF;>' + (isEmpty(item.nick_name) ? '(' + item.nick_name + ')' : '') + '</span>'" />
                        <span v-if="item.resign.toString() == 'true'" style="color:#F44336">(ลาออก)</span>
                      </v-flex>
                      <v-flex xs12 class="hidden-xs-only">
                        <span class="coco-list-label-text hidden-sm-only">
                          {{ $t("branch") }}:
                          <span>
                            {{ isEmpty(item.branch) ? item.branch : "" }}
                          </span>
                        </span>
                        <span class="coco-list-label-text hidden-sm-only">
                          {{ $t("Department") }}:
                          <span>
                            {{ isEmpty(item.department_name) ? item.department_name : "" }}
                          </span>
                        </span>
                        <span class="coco-list-label-text hidden-sm-only">
                          {{ $t("Position") }}:
                          <span>
                            {{ isEmpty(item.position) ? item.position : "" }}
                          </span>
                        </span>
                        <span class="coco-list-label-icon">
                          <v-icon>access_time</v-icon>
                          <span>{{ formatdate(item.effect_date) }}</span>
                        </span>
                        <span class="coco-list-label-icon">
                          <v-icon>monetization_on</v-icon>
                          <span v-show="currencySymbols == '0'">{{ symbolStyles + " " + formatNumber(item.amount, 2, true) }}</span>
                          <span v-show="currencySymbols == '1'">{{ formatNumber(item.amount, 2, true) + " " + symbolStyles }}</span>
                        </span>
                        <span class="coco-list-label-icon">
                          <v-icon>info</v-icon>
                          <span>{{ isEmpty(item.name) ? item.name : "-" }}</span>
                        </span>
                      </v-flex>
                      <v-flex xs12 class="hidden-sm-and-up">
                        <span class="coco-list-label-icon">
                          <v-icon style="padding-left: 0px;">access_time</v-icon>
                          <span>{{ formatdate(item.effect_date) }}</span>
                        </span>
                        <span class="coco-list-label-icon">
                          <v-icon>monetization_on</v-icon>
                          <span v-show="currencySymbols == '0'">{{ symbolStyles + " " + formatNumber(item.amount, 2, true) }}</span>
                          <span v-show="currencySymbols == '1'">{{ formatNumber(item.amount, 2, true) + " " + symbolStyles }}</span>
                        </span>
                      </v-flex>
                      <v-flex xs12 class="hidden-sm-and-up">
                        <span class="coco-list-label-icon">
                          <v-icon style="padding-left: 0px;">info</v-icon>
                          <span>{{ isEmpty(item.name) ? item.name : "-" }}</span>
                        </span>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex lg4 md6 sm6 xs12 pa-1>
                        <span class="coco-list-label-text hidden-sm-only">
                          {{ $t("branch_pay") }}:
                          <span>
                            {{ isEmpty(item.branch_pay) ? item.branch_pay : "" }}
                          </span>
                        </span>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex lg4 md6 sm6 xs12 pa-1>
                        <v-checkbox :label="$t('not_cal_tax')" value="1" v-model="item.not_cal_tax" disabled />
                      </v-flex>
                      <v-flex lg4 md6 sm6 xs12 pa-1>
                        <v-checkbox label="รวมรายได้ในประกันสังคม" value="1" v-model="item.not_cal_ss" disabled />
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex lg2 md2 sm2 xs12>
                    <v-layout row wrap>
                      <v-flex md12 sm12 xs12 text-xs-right>
                        <v-layout row wrap text-xs-right>
                          <v-flex offset-lg5 offset-md3 offset-xs4 lg3 md4 xs6>
                            <v-tooltip bottom>
                              <v-btn slot="activator" color="warning" icon flat @click="EditItem(item, index)">
                                <v-icon>edit</v-icon>
                              </v-btn>
                              <span>{{ $t("edit") }}</span>
                            </v-tooltip>
                          </v-flex>
                          <v-flex lg3 md4 xs2>
                            <v-tooltip bottom>
                              <v-btn slot="activator" color="error" icon flat @click="deleteItem(item, index)">
                                <v-icon>delete</v-icon>
                              </v-btn>
                              <span>{{ $t("delete") }}</span>
                            </v-tooltip>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex xs12 class="coco-list-divider">
                    <v-divider />
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-flex>

      <!-- Delete Dialog -->
      <v-flex md12 sm12 xs12>
        <delete-dialog :json_data="delete_dialog_data" v-on:close-dialog="onCloseDeleteDialog" v-on:delete-item="onDelete" />
      </v-flex>

      <!-- FormEdit -->
      <v-layout row justify-center>
        <v-dialog v-model="dialog" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <span class="headline">{{ $t("EditDocument") }}</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md6>
                    <v-text-field :label="$t('code')" v-model="form_dialog.emp_code" required readonly></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field :label="$t('name')" v-model="form_dialog.first_name" required></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field :label="$t('amount')" v-model="form_dialog.amount" required></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field :label="$t('detail')" v-model="form_dialog.name" required></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field :label="$t('effective_date')" v-model="form_dialog.effect_date" required></v-text-field>
                  </v-flex>
                  <v-flex md6 sm6 xs12 pa-1>
                    <v-select :items="tax_type" :label="$t('TaxType')" v-model="form_dialog.tax_type" item-text="text" item-value="code"></v-select>
                  </v-flex>
                  <v-flex md6 sm6 xs12 pa-1>
                    <v-text-field :label="$t('TaxPercent')" v-model="form_dialog.tax_percent" required type="number" hide-details />
                  </v-flex>
                  <v-flex md6 sm6 xs12 pa-1>
                    <v-text-field :label="$t('branch_pay')" v-model="form_dialog.branch_pay" hide-details />
                  </v-flex>
                  <v-layout row wrap>
                    <v-flex xs12 pa-1>
                      <v-checkbox :label="$t('not_cal_tax')" value="1" v-model="form_dialog.not_cal_tax" />
                    </v-flex>
                    <v-flex xs12 pa-1>
                      <v-checkbox :label="$t('company_pay')" value="1" v-model="form_dialog.company_pay" />
                    </v-flex>
                  </v-layout>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="dialog = false">Close</v-btn>
              <v-btn
                color="blue darken-1"
                flat
                @click="
                  dialog = false;
                  onUpdate();
                "
                >Save</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
      <!-- Form Create Doc -->
      <v-layout row justify-center>
        <v-dialog v-model="dialog_create" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <span class="headline">{{ $t("CreateDocument") }}</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md6>
                    <v-text-field :label="$t('date')" type="date" v-model="form_dialog_create.date" required hide-details :rules="form_rules.date" />
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field :label="$t('detail')" v-model="form_dialog_create.remark" required />
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="dialog_create = false">Close</v-btn>
              <v-btn color="blue darken-1" flat @click="DownloadExampleExcel()">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
      <!-- recommend dialog -->
      <v-dialog v-model="info_dialog" width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>
            {{ $t("recommend") }}
          </v-card-title>

          <v-card-text>
            <v-flex md12 sm12 xs12 pa-2>
              <br />
              <h4 class="text-xl-left">การกรอกข้อมูลในไฟล์ excle ที่ ดาวน์โหลดตัวอย่าง</h4>
              <br />
            </v-flex>
            <v-layout row warp>
              <v-flex md6 sm6 xs12>
                <p class="text-xl-left">
                  <strong>ประเภทภาษี มาตรา 40</strong> <br />
                  - มาตรา40(1) ค่าจ้างเงินเดือน = 1 <br />
                  - มาตรา40(2) ค่านายหน้า ค่าคอม = 2 <br />
                  - มาตรา40(3) ค่าลิขสิทธิ์ = 3<br />
                  - มาตรา40(4) ดอกเบี้ยเงินปันผล = 4<br />
                  - มาตรา40(5) ค่าเช่า = 5<br />
                  - มาตรา40(6) ค่าวิชาชีพอิสระ = 6<br />
                  - มาตรา40(7) ค่ารับเหมา = 7<br />
                  - มาตรา40(8) เงินได้อื่นๆ = 8
                </p>
              </v-flex>
              <v-flex md6 sm6 xs12>
                <p class="text-xl-left">
                  <strong>หักภาษี</strong> <br />
                  - การหักภาษีจะหักเป็น %
                </p>
                <p class="text-xl-left">
                  <strong>ไม่นำไปคำนวณภาษีเงินได้</strong> <br />
                  - คำนวณ = 0 <br />
                  - ไม่คำนวณ = 1
                </p>
                <p class="text-xl-left">
                  <strong>ทางบริษัทฯ เป็นผู้รับภาระในการจ่ายให้</strong> <br />
                  - ไม่จ่ายให้ = 0 <br />
                  - จ่ายให้ = 1
                </p>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="info_dialog = false">
              {{ $t("close") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Snackbar -->
      <v-snackbar v-model="snack_model.status" :timeout="3500" :top="'top'" :color="snack_model.type">
        {{ snack_model.msg }}
        <v-btn dark flat icon @click="snack_model.status = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-layout>
  </v-container>
</template>
<script>
/* eslint-disable */
import { mapState, mapActions } from "vuex";
import DocumentService from "@/services/DocumentService";
import SettingService from "@/services/SettingService";
import EmployeeService from "@/services/EmployeeService";
import DeleteDialog from "../../components/master/dialogs/DeleteDialog";
import Empimage from "../../components/getempimage.vue";
import UserService from "@/services/UserService";
import XLSX from "xlsx";
import moment, { locale } from "moment";
import Utils from "@/utils/";
import { constants } from "crypto";
export default {
  data: () => ({
    info_dialog: false,
    dialog_create: false,
    branch: "",
    department: "",
    branch_items: [],
    department_items: [],
    Employee_list: [],
    Employee_items: [],
    dialog_loading: false,
    isChecked: false,
    form_valid: false,
    dialog: false,
    snackbar: false,
    errmsg: "",
    progress: 0,
    form_dialog_data: {
      status: false,
      save_type: String,
      data: Object,
    },
    form_rules: {
      date: [(v) => !!v || "do not empty."],
    },
    delete_dialog_data: {
      status: false,
    },
    snack_model: {
      status: "",
      msg: "",
      type: "",
    },
    index: 0,
    tax_type: [
      { code: "1", text: "มาตรา40(1) ค่าจ้างเงินเดือน" },
      { code: "2", text: "มาตรา40(2) ค่านายหน้า ค่าคอม" },
      { code: "3", text: "มาตรา40(3) ค่าลิขสิทธิ์" },
      { code: "4", text: "มาตรา40(4) ดอกเบี้ยเงินปันผล" },
      { code: "5", text: "มาตรา40(5) ค่าเช่า" },
      { code: "6", text: "มาตรา40(6) ค่าวิชาชีพอิสระ" },
      { code: "7", text: "มาตรา40(7) ค่ารับเหมา" },
      { code: "8", text: "มาตรา40(8) เงินได้อื่นๆ" },
    ],
    form_dialog: {
      amount: "",
      name: "",
      emp_code: "",
      detailincome: "",
      effect_date: "",
      not_cal_tax: "0",
      company_pay: "0",
      tax_type: "1",
      tax_percent: 0,
      company_id: localStorage._company_guid,
    },
    form_dialog_create: {
      date: "",
      remark: "",
    },

    detail_example: [],
    datas: {
      code: "",
      remark: "",
      date: new Date().toISOString().slice(0, 10),
      creator_code: localStorage._usercode,
      details: [],
      company_id: localStorage._company_guid,
    },
    results: [],
    IncomeData: [],
    name: [],
    permission_view: false,
    permission_edit: false,
    checkdata: true,
    admin: false,
    empCode: localStorage._empcode,
    permission: [],
    empImport: [],
    empNewList: [],
    detail: [],
  }),

  components: {
    DeleteDialog,
    Empimage,
  },
  computed: {
    ...mapState("app", ["showLoading", "formatDates", "symbolStyles", "currencySymbols"]),
    ...mapState("filter", ["Employee_List"]),
    ...mapState("permissionmenu", ["permission_List"]),

    selectAllEmp() {
      return this.name.length === this.Employee_list.length;
    },
    selectSomeEmp() {
      console.log(this.name);
      return this.name.length > 0 && !this.selectAllEmp;
    },
  },
  created: async function() {
    this.admin = localStorage._is_admin;
    await UserService.getpermissionByusercode(this.empCode)
      .then((res) => {
        this.permission = res.data.permission;
        console.log(res);
      })
      .catch((err) => {});
    await this.checkpermission("ImportFileIncome");
    this.doNewGuid();
    this.getEmployee("refesh");
    this.getProfileBranchList();
    this.commitSetToolbar({ patternTool: "0" });
  },
  methods: {
    ...mapActions("filter", ["getEmployee"]),
    ...mapActions("app", ["commitSetToolbar"]),

    goto(path) {
      this.$router.push("/" + path);
    },
    checkpermission(page) {
      let checkEdit = false;
      let checkView = false;
      if (this.permission.length != 0) {
        this.permission.forEach((element) => {
          if (page == element.module_name) {
            checkEdit = element.edit;
            checkView = element.reads;
          }
        });
      } else {
        checkEdit = false;
        checkView = false;
      }
      this.permission_edit = checkEdit;
      this.permission_view = checkView;
    },
    formatdate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    formatdateDoc(date) {
      return moment(date).format("DDMMYYYY");
    },
    formatNumber(value, digit, hasComma) {
      return Utils.formatNumber(value, digit, hasComma);
    },
    isEmpty(value) {
      return Utils.isEmpty(value);
    },
    doNewGuid() {
      this.datas.code = Utils.newGuid("INC" + localStorage._company_guid.substr(0, 6).toUpperCase() + this.formatdateDoc(this.datas.date));
    },
    CreateDoc() {
      let v = this;
      v.detail_example = [];
      // if (v.name.length > 0) {
  

        v.detail_example.push({
          รหัส: "EX001",
          คำนำหน้า:"นาย",
          ชื่อ: "ทดสอบ",
          นามสกุล: "นามสกุล",
          วันที่มีผล: "2024-01-01",
          สาขา: "สาขา",
          รายละเอียดรายรับ: "รายได้อื่นๆ",
          ประเภทภาษีมาตรา40: "1",
          หักภาษี: "0",
          ไม่นำไปคำนวณภาษีเงินได้: "0",
          รวมรายได้ในประกันสังคม: "0",
          ทางบริษัทฯเป็นผู้รับภาระในการจ่ายให้: "0",
          จำนวน: "100",
          ที่อยู่: " ",
        });

        var config = { raw: true, type: "string" };
        var Example = XLSX.utils.json_to_sheet(v.detail_example, config);
        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, Example, "เอกสารนำเข้ารายได้");
        XLSX.writeFile(wb, "เอกสารนำเข้ารายได้" + ".xlsx");
    },
    DownloadExampleExcel() {
      let v = this;
      console.log("DownloadExampleExcel");
      console.log(v.name);
      v.detail_example = [];
      // if (v.name.length > 0) {
      if (v.form_dialog_create.date != "") {
        v.dialog_create = false;

        v.detail_example.push({
          รหัส: "EX001",
          คำนำหน้า:"นาย",
          ชื่อ: "ทดสอบ",
          นามสกุล: "นามสกุล",
          วันที่มีผล: "'2024-01-01",
          สาขา: "สาขา",
          รายละเอียดรายรับ: "รายได้อื่นๆ",
          ประเภทภาษีมาตรา40: "1",
          หักภาษี: "0",
          ไม่นำไปคำนวณภาษีเงินได้: "0",
          รวมรายได้ในประกันสังคม: "0",
          ทางบริษัทฯเป็นผู้รับภาระในการจ่ายให้: "0",
          จำนวน: " ",
          ที่อยู่: " ",
        });

        var config = { raw: true, type: "string" };
        var Example = XLSX.utils.json_to_sheet(v.detail_example, config);
        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, Example, "เอกสารนำเข้ารายได้");
        XLSX.writeFile(wb, "เอกสารนำเข้ารายได้" + ".xlsx");
      } else {
        this.snack_model.status = true;
        this.snack_model.msg = "กรุณากรอกวันที่มีผล";
        this.snack_model.type = "error";
      }
      // } else {
      //   this.snack_model.status = true;
      //   this.snack_model.msg = "กรุณาเลือกรายชื่อพนักงานก่อน";
      //   this.snack_model.type = "error";
      // }
      this.form_dialog_create.date = "";
      this.form_dialog_create.remark = "";
    },
    ImportExcel() {
      let v = this;
      var config = { raw: true, type: "string" };
      var reader = new FileReader();
      this.dialog_loading = true;
      reader.readAsArrayBuffer(this.$refs.myFiles.files[0]);
      reader.onload = function(e) {
        var data = new Uint8Array(reader.result);
        var wb = XLSX.read(data, { type: "array" });
        var firstSheetName = wb.SheetNames[0];
        var worksheet = wb.Sheets[firstSheetName];
        v.results = XLSX.utils.sheet_to_json(worksheet, config);
        console.log(v.results);
        console.log("5555");
        v.datas.details = [];
        for (let index = 0; index < v.results.length; index++) {
          if (
            v.results[index].รหัส != " " &&
            v.results[index].วันที่มีผล != " " &&
            v.results[index].จำนวน != " " &&
            v.results[index].จำนวน != undefined &&
            v.results[index].รายละเอียดรายรับ != " " &&
            v.results[index].รายละเอียดรายรับ != undefined &&
            v.results[index].ประเภทภาษีมาตรา40 != " " &&
            v.results[index].ประเภทภาษีมาตรา40 != undefined &&
            v.results[index].รวมรายได้ในประกันสังคม != " " &&
            v.results[index].รวมรายได้ในประกันสังคม != undefined &&
            v.results[index].หักภาษี != undefined &&
            v.results[index].ไม่นำไปคำนวณภาษีเงินได้ != " " &&
            v.results[index].ไม่นำไปคำนวณภาษีเงินได้ != undefined &&
            v.results[index].ทางบริษัทฯเป็นผู้รับภาระในการจ่ายให้ != " " &&
            v.results[index].ทางบริษัทฯเป็นผู้รับภาระในการจ่ายให้ != undefined
          ) {
            var address = "";
            if (v.results[index].ที่อยู่ != undefined || v.results[index].ที่อยู่ != "") {
              address = v.results[index].ที่อยู่ + "";
            }
            var surname = "";
            if (v.results[index].นามสกุล != undefined || v.results[index].นามสกุล != "") {
              surname = v.results[index].นามสกุล + "";
            }
            var nametitle = "";
            if (v.results[index].คำนำหน้า != undefined || v.results[index].คำนำหน้า != "") {
              nametitle = v.results[index].คำนำหน้า + "";
            }
            var branchPay = "";
            if (v.results[index].สาขา != undefined || v.results[index].สาขา != "") {
              branchPay = v.results[index].สาขา + "";
            }
            v.datas.details.push({
              name_title: nametitle,
              name_1: v.results[index].ชื่อ + "",
              last_name: surname,
              emp_code: v.results[index].รหัส,
              effect_date: v.results[index].วันที่มีผล,
              amount: v.results[index].จำนวน,
              name: v.results[index].รายละเอียดรายรับ,
              tax_type: v.results[index].ประเภทภาษีมาตรา40 + "",
              tax_percent: parseInt(v.results[index].หักภาษี),
              not_cal_tax: v.results[index].ไม่นำไปคำนวณภาษีเงินได้ + "",
              not_cal_ss : v.results[index].รวมรายได้ในประกันสังคม + "",
              company_pay: v.results[index].ทางบริษัทฯเป็นผู้รับภาระในการจ่ายให้ + "",
              address: address,
              branch_pay: branchPay,
              company_id: localStorage._company_guid,
            });
          } else if (v.results[index].รายละเอียดรายรับ == undefined) {
            v.snack_model.status = true;
            v.snack_model.msg = "เอกสารไม่ถูกต้องกรุณาอัพโหลดเอกสารใหม่";
            v.snack_model.type = "error";
          } else {
            v.snack_model.status = true;
            v.snack_model.msg = "กรุณากรอกข้อมูลให้ครบถ้วน";
            v.snack_model.type = "error";
          }
        }
        console.log(v.datas);
        DocumentService.CheckDetail(v.datas.details)
          .then(async (res) => {
            console.log("res.data", res.data);
            v.IncomeData = v.datas.details;

            v.IncomeData.forEach((element) => {
              console.log("element", element);

              const resElement = res.data.find((resEl) => resEl.emp_code === element.emp_code);
              if (resElement) {
                element.tax_type = element.tax_type;
                element.tax_percent = element.tax_percent;
                element.not_cal_tax = element.not_cal_tax;
                element.not_cal_ss = element.not_cal_ss.toString();
                element.company_pay = element.company_pay;

                element.resign = resElement.resign;
                element.name = resElement.name;

                element.status = resElement.status;
                element.branch = resElement.branch;
                element.branch_name = resElement.branch_name;
                element.department_name = resElement.department_name;
                element.nick_name = resElement.nick_name;
                element.department = resElement.department;
                element.position = resElement.position;
                element.name_title = resElement.name_title;
                element.first_name = resElement.first_name;
                element.last_name = resElement.last_name;
                element.emp_images = resElement.emp_images;
                element.doc_ref = resElement.doc_ref;

                element.emp_code = resElement.emp_code;

                element.company_id = resElement.company_id;
              }

              if (element.first_name == null || element.first_name == undefined || element.first_name == "") {
                if (!v.empNewList.some((existingItem) => existingItem.emp_code === element.emp_code)) {
                  v.empNewList.push({
                    emp_code: element.emp_code,
                    first_name: element.name_1,
                    last_name: element.last_name,
                    address: element.address,
                    start_date: element.effect_date,
                    name_title: element.name_title,
                  });
                }
              }
            });
          
            setTimeout(() => {
              if (v.empNewList.length > 0) {
                console.log("empNewList", v.empNewList);
                // v.importEmp(v.empNewList);
              }
              v.dialog_loading = false;
              console.log("CheckDetail");
              console.log(v.IncomeData);
            }, 1500);
          })
          .catch((err) => {
            v.snack_model.status = true;
            v.snack_model.msg = "ไม่พบข้อมูล";
            v.snack_model.type = "error";
          });
      };
      reader.onerror = function(e) {
        this.snack_model.status = true;
        this.snack_model.msg = "กรุณากรอกข้อมูลให้ครบถ้วน";
        this.snack_model.type = "error";
      };
    },
    chunkArray(array, size) {
      const result = [];
      for (let i = 0; i < array.length; i += size) {
        const chunk = array.slice(i, i + size);
        result.push(chunk);
      }
      return result;
    },
    async importEmployees() {
      this.dialog_loading = true;
      const chunks = this.chunkArray(this.empImport, 10);
      const totalChunks = chunks.length;
      let completedChunks = 0;
      var v = this;
      for (const chunk of chunks) {
        try {
          const res = await EmployeeService.importEmployee(chunk);
          console.log("Batch import successful", res);
          completedChunks++;
          this.updateProgressBar(completedChunks, totalChunks);
        } catch (err) {
          console.error(err);
          this.dialog_loading = false;
          this.snackbar = true;
          this.errmsg = err.message;
          break; // Stop processing if there is an error
        }
      }
      if (completedChunks === totalChunks) {
        console.log("All chunks processed successfully");
        v.process = 0;
        DocumentService.CheckDetail(v.datas.details)
          .then(async (res) => {
            // v.IncomeData = res.data;
            // v.IncomeData.forEach((element) => {
            //   v.datas.details.forEach((el) => {
            //     if (element.emp_code == el.emp_code) {
            //       if (element.first_name == null || element.first_name == undefined || element.first_name == "") {
            //         v.empNewList.push({ emp_code: element.emp_code, first_name: el.name_1, address: el.address });
            //       }

            //       element.tax_type = el.tax_type;
            //       element.tax_percent = el.tax_percent;
            //       element.not_cal_tax = el.not_cal_tax;
            //       element.company_pay = el.company_pay;
            //       element.company_id = localStorage._company_guid;
            //     }
            //   });
            // });
            console.log("res.data", res.data);
            v.IncomeData = v.datas.details;

            v.IncomeData.forEach((element) => {
              console.log("element", element);

              const resElement = res.data.find((resEl) => resEl.emp_code === element.emp_code);
              if (resElement) {
                element.tax_type = element.tax_type;
                element.tax_percent = element.tax_percent;
                element.not_cal_tax = element.not_cal_tax;
                element.not_cal_ss = element.not_cal_ss.toString();
                element.company_pay = element.company_pay;

                element.resign = resElement.resign;
                element.name = resElement.name;

                element.status = resElement.status;
                element.branch = resElement.branch;
                element.branch_name = resElement.branch_name;
                element.department_name = resElement.department_name;
                element.nick_name = resElement.nick_name;
                element.department = resElement.department;
                element.position = resElement.position;
                element.name_title = resElement.name_title;
                element.first_name = resElement.first_name;
                element.last_name = resElement.last_name;
                element.emp_images = resElement.emp_images;
                element.doc_ref = resElement.doc_ref;

                element.emp_code = resElement.emp_code;

                element.company_id = resElement.company_id;
              }

              if (element.first_name == null || element.first_name == undefined || element.first_name == "") {
                if (!v.empNewList.some((existingItem) => existingItem.emp_code === element.emp_code)) {
                  v.empNewList.push({
                    emp_code: element.emp_code,
                    first_name: element.name_1,
                    last_name: element.last_name,
                    address: element.address,
                    start_date: element.effect_date,
                    name_title: element.name_title,
                  });
                }
              }
            });
            this.dialog_loading = false;
            console.log("CheckDetail");
            console.log(v.IncomeData);
          })
          .catch((err) => {
            v.dialog_loading = false;
          v.snackbar = true;
          v.errmsg = err.message;
            v.snack_model.status = true;
            v.snack_model.msg = "ไม่พบข้อมูล";
            v.snack_model.type = "error";
          });
        this.empNewList = [];
      }
    },

    updateProgressBar(completedChunks, totalChunks) {
      this.progress = Math.round((completedChunks / totalChunks) * 100);
    },
    async importEmp() {
      this.dialog_loading = true;
      this.empImport = [];
      var inputData = this.empNewList;
      let v = this;
      console.log("this.empNewList", inputData);
      v.snack_model.status = true;
      v.snack_model.msg = "กำลังนำเข้าข้อมูลพนักงาน";
      v.snack_model.type = "success";
      if (inputData.length > 0) {
        var year = new Date().toISOString().substr(0, 4);
        this.detail = [];
        await SettingService.getTaxdetail(year).then((res) => {
          if (res.data != "") {
            console.log("", res.data);
            res.data.tax_detail.forEach((element) => {
              if (element.name == "personal") {
                this.detail.push({
                  year_tax: year,
                  name: element.name,
                  type: element.type,
                  percent: element.percent,
                  max: element.max,
                  value: element.max,
                  company_id: localStorage._company_guid,
                });
              } else {
                this.detail.push({
                  year_tax: year,
                  name: element.name,
                  type: element.type,
                  percent: element.percent,
                  max: element.max,
                  value: 0,
                  company_id: localStorage._company_guid,
                });
              }
            });
          }
        });
        console.log("this.detail", this.detail);
        await inputData.forEach((element) => {
          let salary = 0;
          let earningday = "0";
          let earninghour = "0";
          let branchEmp = "";
          salary = element.salary;
     
          if (this.branch_items.length > 0) {
            branchEmp = this.branch_items[0].code;
          }
          v.empImport.push({
            company_id: localStorage._company_guid,
            company_guid: localStorage._company_guid,
            user_name: "",
            user_password: "",
            code: element.emp_code,
            name_title: element.name_title,
            nick_name: "",
            is_auto_ss: "0",
            is_auto_tax: "0",
            is_training: "0",
            is_special: "1",
            plan_type: "0",
            first_name: element.first_name,
            last_name: element.last_name,
            weekends: "",
            holiday_profile: "",
            deduct_ss: 0,
            deduct_tax: 0,
            calworkhour: 8,
            income_craft: 0,
            current_craft: 0,
            income_position: 0,
            current_position: 0,
            income_special: 0,
            promptpay_number: "",
            not_cal_time: "0",
            payment_type: 0,

            nationality: "",
            emp_type: "0",
            earning_daytype: "0",
            daily_monday: 0,
            daily_tuesday: 0,
            daily_wednesday: 0,
            daily_thursday: 0,
            daily_friday: 0,
            daily_saturday: 0,
            daily_sunday: 0,
            daily_holiday: 0,
            earning_hourtype: "0",
            hour_monday: 0,
            hour_tuesday: 0,
            hour_wednesday: 0,
            hour_thursday: 0,
            hour_friday: 0,
            hour_saturday: 0,
            hour_sunday: 0,
            hour_holiday: 0,
            form_hour_1: 0,
            to_hour_1: 0,
            hourearning_1: 0,
            form_hour_2: 0,
            to_hour_2: 0,
            hourearning_2: 0,
            birth_date: "",
            address: element.address,
            gender: "male",
            phone_num: "",
            email: "",
            race: "",
            line_id: "",
            citizen_id: element.emp_code,
            position: "",
            approver: localStorage._usercode,
            start_work_date: "2023-01-01",
            packing_date: "",
            status: "1",
            branch: branchEmp,
            faction: "",
            department: "",
            start_salary: 0,
            packing_salary: 0,
            daily_earnings: 0,
            hourly_earnings: 0,
            book_bank: "",
            bank_name: "",
            bank_code: "",
            shift_profile: "",
            conditions_profile: "",
            emp_images: [],
            tax_year: year,
            year_leave: new Date().toISOString().substr(0, 4),
            taxsetting: {
              company_id: localStorage._company_guid,
              less_exp_rate: 50,
              less_exp_base: 100000,
              reduce_person: 60000,
              reduce_spouse: 0,
              reduce_child_rate: 0,
              reduce_child_base: 30000,
              reduce_parent_rate: 0,
              reduce_parent_base: 30000,
              reduce_handucap_rate: 0,
              reduce_handucap_base: 30000,
              reduce_insurance_base: 100000,
              reduce_insurance: 0,
              reduce_parent_insurance_base: 15000,
              reduce_parent_insurance: 0,
              reduce_inc_residence_base: 100000,
              reduce_inc_residence: 0,
              reduce_ltf: 0,
              reduce_long_insurance: 0,
              reduce_rmf: 0,
              reduct_name_1: "",
              reduct_name_2: "",
              reduct_name_3: "",
              reduct_name_4: "",
              reduct_name_5: "",
              reduct_name_6: "",
              reduct_name_7: "",
              reduct_name_8: "",
              reduct_name_9: "",
              reduct_name_10: "",
              reduct_value_1: 0,
              reduct_value_2: 0,
              reduct_value_3: 0,
              reduct_value_4: 0,
              reduct_value_5: 0,
              reduct_value_6: 0,
              reduct_value_7: 0,
              reduct_value_8: 0,
              reduct_value_9: 0,
              reduct_value_10: 0,
            },

            personal_leave_day: 0,
            personal_leave_hour: 0,
            sick_leave_day: 0,
            sick_leave_hour: 0,
            vacation_leave_day: 0,
            vacation_leave_hour: 0,
            ordination_leave_day: 0,
            ordination_leave_hour: 0,
            maternity_leave_day: 0,
            maternity_leave_hour: 0,
            military_service_leave_day: 0,
            military_service_leave_hour: 0,
            other_leave_day: 0,
            other_leave_hour: 0,
            creator_code: localStorage._usercode,
            tax_detail: this.detail,
            other_income_detail: [],

          });
        });

        // let check = false;
        // await this.name.forEach((element) => {
        //   check = this.filterItems(element.code);
        //   if (!check) {
        //     v.json_create.push(element);
        //   } else {
        //  //   v.json_update.push(element);
        //   }
        // });

        console.log("create", v.empImport);
        // console.log("update", v.json_update);
        if (v.empImport.length > 0) {
          this.importEmployees(v.empImport);

          // EmployeeService.importEmployee(v.empImport)
          //   .then((res) => {
          //     console.log(res);

          //     DocumentService.CheckDetail(v.datas.details)
          //       .then(async (res) => {
          //         v.IncomeData = res.data;
          //         v.IncomeData.forEach((element) => {
          //           v.datas.details.forEach((el) => {
          //             if (element.emp_code == el.emp_code) {
          //               if (element.first_name == null || element.first_name == undefined || element.first_name == "") {
          //                 v.empNewList.push({ emp_code: element.emp_code, first_name: el.name_1, address: el.address });
          //               }

          //               element.tax_type = el.tax_type;
          //               element.tax_percent = el.tax_percent;
          //               element.not_cal_tax = el.not_cal_tax;
          //               element.company_pay = el.company_pay;
          //               element.company_id = localStorage._company_guid;
          //             }
          //           });
          //         });
          //         this.dialog_loading = false;
          //         console.log("CheckDetail");
          //         console.log(v.IncomeData);
          //       })
          //       .catch((err) => {
          //         v.snack_model.status = true;
          //         v.snack_model.msg = "ไม่พบข้อมูล";
          //         v.snack_model.type = "error";
          //       });
          //     this.empNewList = [];
          //   })
          //   .catch((err) => {
          //     console.log(err);
          //     this.dialog_loading = false;
          //     this.snackbar = true;
          //     this.errmsg = err;
          //   });
        }
      }
    },
    getProfileBranchList() {
      SettingService.getProfileBranchList()
        .then((res) => {
          console.log(res);
          if (res.data.content.length > 0) {
            this.branch_items = res.data.content;
            console.log("eeee", this.branch_items);
          } else {
            console.log("ddddd");
            console.log(this.Employee_List);
            this.Employee_List.forEach((emp) => {
              this.Employee_list.push(emp);
            });
            console.log(this.Employee_list);
          }
        })
        .catch((err) => {
          console.log(err);

          console.log("ddddd");
          this.Employee_List.forEach((emp) => {
            this.Employee_list.push(emp);
          });
          console.log(this.Employee_list);
        });
    },
    getProfileDepartment() {
      SettingService.getProfileDepartmentList()
        .then((res) => {
          this.department_items = res.data.content;
          console.log(this.department_items);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getProfileDepartmentList() {
      this.department = "";
      SettingService.getDepartmentByBranch(this.branch)
        .then((res) => {
          this.department_items = res.data;
          console.log(this.department_items);
          this.getEmployeeList();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getEmployeeList() {
      var position = "";
      var search = "";
      var page = "";
      EmployeeService.getEmployee(this.branch, this.department, position, search, page)
        .then((res) => {
          this.Employee_items = res.data.content;
          this.Employee_list = [];
          this.Employee_items.forEach((emp) => {
            if (emp.is_active) {
              this.Employee_list.push({
                code: emp.code,
                name: emp.code + " - " + emp.first_name + " " + emp.last_name,
              });
            }
          });
          console.log(this.Employee_list);
        })
        .catch((err) => {
          console.log(err);
        });
    },

    onCloseDeleteDialog() {
      this.delete_dialog_data.status = false;
    },
    deleteItem(data, index) {
      this.delete_dialog_data.status = true;
      let message = "<p>" + this.$t("question.delete") + " " + data.emp_code + " " + data.first_name + data.last_name + "?</p>";
      this.delete_dialog_data.message = message;
      this.delete_dialog_data.index = index;
    },
    EditItem(data, index) {
      this.dialog = true;
      this.form_dialog = data;
      this.index = index;
      console.log(this.form_dialog);
    },

    onDelete() {
      console.log(this.delete_dialog_data.index);
      this.IncomeData.splice(this.delete_dialog_data.index, 1);
      this.datas.details.splice(this.delete_dialog_data.index, 1);
      console.log("ondelete: importincome", this.datas);
    },
    timedRefresh(timeoutPeriod) {
      setTimeout("location.reload(true);", timeoutPeriod);
    },
    // findArrayObj(arr) {
    //   var arr_data = [];
    //   var arr_detail = [];
    //   arr.forEach(element => {
    //     if (element.resign.toString() == "false") {
    //       arr_data.push({ emp_code: element.emp_code });
    //     }
    //   });
    //   arr_data.forEach(element => {
    //     const data_income = this.datas.details.find(
    //       el => el.emp_code == element.emp_code
    //     );
    //     arr_detail.push(data_income);
    //   });

    //   return arr_detail;
    // },
    onSave() {
      let v = this;
      this.process = 0;
      this.datas.details = this.IncomeData;
      console.log(this.datas);
      console.log("4545");
      v.IncomeData.forEach((data) => {
        if (data.status == false) {
          v.checkdata = false;
        }
      });

      console.log(v.checkdata);
      v.dialog_loading = true;
      if (v.checkdata != false) {
        console.log(this.datas);
        this.datas.company_id = localStorage._company_guid;

        this.datas.details.forEach((element) => {
        if (element.not_cal_ss == '0') {
          element.not_cal_ss = 0;
        }else{
          element.not_cal_ss = 1;
        }
      
      });

        DocumentService.createIncome(this.datas)
          .then((res) => {
            console.log(res);
            v.dialog_loading = false;
            v.snack_model.status = true;
            v.snack_model.msg = this.$t("message.save");
            v.snack_model.type = "success";
            v.goto("ImportFile/ListIncome");
          })
          .catch((err) => {
            v.dialog_loading = false;
            v.snack_model.status = true;
            v.snack_model.msg = err;
            v.snack_model.type = "error";
          });
      } else {
        v.dialog_loading = false;
        v.snack_model.status = true;
        v.snack_model.msg = "กรุณาตรวจสอบข้อมูลและทำการอัพโหลดไฟล์ใหม่";
        v.snack_model.type = "error";
        window.onload = this.timedRefresh(1500);
      }
    },

    onUpdate() {
      let v = this;
      console.log(v.form_dialog);
      if (v.form_dialog.not_cal_tax == null) {
        v.form_dialog.not_cal_tax = "0";
      }
      if (v.form_dialog.company_pay == null) {
        v.form_dialog.company_pay = "0";
      }

      (v.datas.details[v.index].emp_code = v.form_dialog.emp_code),
        (v.datas.details[v.index].effect_date = v.form_dialog.effect_date),
        (v.datas.details[v.index].name = v.form_dialog.name),
        (v.datas.details[v.index].amount = v.form_dialog.amount),
        (v.datas.details[v.index].not_cal_tax = v.form_dialog.not_cal_tax),
        (v.datas.details[v.index].company_pay = v.form_dialog.company_pay),
        (v.datas.details[v.index].tax_type = v.form_dialog.tax_type),
        (v.datas.details[v.index].tax_percent = v.form_dialog.tax_percent),
        (v.datas.details[v.index].branch_pay = v.form_dialog.branch_pay),
        (this.snack_model.status = true);
      this.snack_model.msg = this.$t("message.update");
      this.snack_model.type = "success";
    },
    back() {
      location.reload();
    },
    backlist() {
      this.goto("ImportFile/ListIncome");
    },
    toggle() {
      this.$nextTick(() => {
        console.log(this.selectAllEmp);
        if (this.selectAllEmp) {
          this.name = [];
          this.isChecked = false;
        } else {
          this.isChecked = true;
          this.name = [];
          this.Employee_list.forEach((data) => {
            this.name.push(data.name);
          });
        }
      });
    },
  },
};
</script>
<style>
@import url("https://fonts.googleapis.com/css?family=Kanit&display=swap");
้ h1,
h2,
h3,
h4,
h5,
h6,
span,
p {
  font-family: "Kanit", sans-serif;
}
.v-input--selection-controls {
  margin-top: 0;
}
.button-wrapper {
  position: relative;
  width: 150px;
  text-align: center;
  margin-top: 5px;
  margin-right: 15px;
  margin-bottom: 5px;
}

.button-wrapper span.label {
  position: relative;
  display: inline-block;
  width: 100%;
  background: #00bfff;
  cursor: pointer;
  color: #fff;
  padding: 10px 0;
  text-transform: uppercase;
  font-size: 12px;
  box-shadow: 0px 2px 2px grey;
}

#file {
  display: inline-block;
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 50px;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
}
.checkEmp .theme--light.v-icon {
  color: #1976d2 !important;
}
</style>
